import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app.component";
import { AppRoutes } from "./app.routing";
import { AuthGuard } from "./guards/auth-guard.service";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { LoginModule } from "./login/login.module";
import { CancelOrderStatusConfigComponent } from "./modals/cancel-order-status-config/cancel-order-status-config.component";
import { EditOrderCancelReasonComponent } from "./modals/edit-order-cancel-reason/edit-order-cancel-reason.component";
import { FailureComponent } from "./modals/failure/failure.component";
import { MediaUploadCopyComponent } from "./modals/media-upload-copy/media-upload-copy.component";
import { OrderedProductsComponent } from "./modals/ordered-products/ordered-products.component";
import { RefundDenyComponent } from "./modals/refund-deny/refund-deny.component";
import { StatusRejectComponent } from "./modals/status-reject/status-reject.component";
import { SubscriptionExpireComponent } from "./modals/subscription-expire/subscription-expire.component";
import { UpdateStatusComponent } from "./modals/update-status/update-status.component";
import { ViewAddressComponent } from "./modals/view-address/view-address.component";
import { ViewCouponComponent } from "./modals/view-coupon/view-coupon.component";
import { ViewModalComponent } from "./modals/view-modal/view-modal.component";
import { CustomersService } from "./modules/customers/customers.service";
import { DeliveryUsersService } from "./modules/deliveryUsers/deliveryUsers.service";
import { OrdersService } from "./modules/orders/orders.service";
import { SellersService } from "./modules/sellers/sellers.service";
import { AuthService } from "./services/auth.service";
import { PageService } from "./services/page-service";
import { FixedPluginModule } from "./shared/fixedplugin/fixedplugin.module";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarModule } from "./shared/navbar/navbar.module";
import { SidebarModule } from "./sidebar/sidebar.module";
import { SignUpModule } from "./sign-up/sign-up.module";
import { ExportOrderdataComponent } from "./modals/export-orderdata/export-orderdata.component";
import { AddWalletComponent } from "./modals/add-wallet/add-wallet.component";
import { RidersListComponent } from "./modals/riders-list/riders-list.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { DeleteCustomerComponent } from "./modals/delete-customer/delete-customer.component";
import { UpdatePasswordComponent } from "./modals/updatePassword/update-password/update-password.component";
import { UpdatedeliveryuserPasswordComponent } from "./modals/updatedeliveryuser-password/updatedeliveryuser-password.component";
import { ExtraAddonsComponent } from "./modals/extra-addons/extra-addons.component";
import { environment } from "environments/environment";
// import { AngularFireModule } from "@angular/fire";
// import { AngularFireAuthModule } from "@angular/fire/auth";
// import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AddHeaderInterceptor } from "./services/interceptor";
import { PlanPopupComponent } from "./modals/plan-popup/plan-popup.component";
import { CancelSubscriptionComponent } from "./modals/cancel-subscription/cancel-subscription.component";
import { ColorPickerModule } from "ngx-color-picker";
import { PurchaseConfirmComponent } from './modals/purchase-confirm/purchase-confirm.component';
import { LimitexceededMsgModalComponent } from './shared/limitexceeded-msg-modal/limitexceeded-msg-modal.component';
import { EditServiceSubCatComponent } from './modals/edit-service-sub-cat/edit-service-sub-cat.component';
import { ServicesoptionsIncludedPopupComponent } from './modals/servicesoptions-included-popup/servicesoptions-included-popup.component';
import { ServicesoptionsExcludedPopupComponent } from './modals/servicesoptions-excluded-popup/servicesoptions-excluded-popup.component';
import { UpdatepasswordServiceprofessionalsComponent } from './modals/updatepassword-serviceprofessionals/updatepassword-serviceprofessionals.component';
import { AddNoteRequestComponent } from './modals/add-note-request/add-note-request.component';
import { UpdateRequestStatusComponent } from './modals/update-request-status/update-request-status.component';
import { IntegrationStepComponent } from './modals/integration-step/integration-step.component';
import { IntegrationSettingsComponent } from './modals/integration-settings/integration-settings.component';
import { ModulesAuthGuardService } from "./guards/modules-auth-guard.service";
import { ModuleauthService } from "./services/moduleauth.service";
import { ModulechildAuthGuardService } from "./guards/modulechild-auth-guard.service";
import { ModuleschildAuthService } from "./services/moduleschild-auth.service";
import { MobilenoSendtemplateComponent } from './modals/mobileno-sendtemplate/mobileno-sendtemplate.component';
import { VerifylibraryStatusComponent } from './modals/verifylibrary-status/verifylibrary-status.component';
import { FilterMenuComponent } from './modals/filter-menu/filter-menu.component';
import { ModernSidebarModule } from "./modern-sidebar/modern-sidebar.module";


@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    StatusRejectComponent,
    SubscriptionExpireComponent,
    UpdateStatusComponent,
    FailureComponent,
    OrderedProductsComponent,
    ViewModalComponent,
    MediaUploadCopyComponent,
    EditOrderCancelReasonComponent,
    CancelOrderStatusConfigComponent,
    RefundDenyComponent,
    ViewCouponComponent,
    ViewAddressComponent,
    ExportOrderdataComponent,
    AddWalletComponent,
    RidersListComponent,
    PrivacyPolicyComponent,
    DeleteCustomerComponent,
    UpdatePasswordComponent,
    UpdatedeliveryuserPasswordComponent,
    PlanPopupComponent,
    CancelSubscriptionComponent,
    PurchaseConfirmComponent,
    LimitexceededMsgModalComponent,
    EditServiceSubCatComponent,
    ServicesoptionsIncludedPopupComponent,
    ServicesoptionsExcludedPopupComponent,
    UpdatepasswordServiceprofessionalsComponent,
    AddNoteRequestComponent,
    UpdateRequestStatusComponent,
    IntegrationStepComponent,
    IntegrationSettingsComponent,
    MobilenoSendtemplateComponent,
    VerifylibraryStatusComponent,
    ExtraAddonsComponent,
    FilterMenuComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      relativeLinkResolution: "legacy",
    }),
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFireAuthModule,
    // AngularFireDatabaseModule,
    SidebarModule,
    ModernSidebarModule,
    HttpClientModule,
    NavbarModule,
    FormsModule,
    ReactiveFormsModule,
    FooterModule,
    FixedPluginModule,
    LoginModule,
    SignUpModule,
    NgbModule,
    ColorPickerModule,
  ],
  providers: [
    PageService,
    AuthGuard,
    AuthService,
    ModulesAuthGuardService,
    ModuleauthService,
    ModulechildAuthGuardService,
    ModuleschildAuthService,
    Location,
    OrdersService,
    SellersService,
    DeliveryUsersService,
    CustomersService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
